import dayjs from 'dayjs';

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const formatDate = (date, language) => {
  if (language === 'en') {
    return dayjs(date).format('MM/DD/YYYY');
  } else if (language === 'es') {
    return dayjs(date).format('DD/MM/YYYY');
  }
  return dayjs(date).format('DD/MM/YYYY');
};

export const getTodayDate = (language) => {
  const today = new Date();
  return formatDate(today, language);
};
